import * as constants from './constants'
import { storage, storageGetDownloadURL, storageRef, storageUploadBytes, } from 'firebaseConfig/clientApp'
import { Profile } from 'types/user'
import { EntryType, getDownloadLink } from './general'
import { logout } from './user'
import { AppDispatch, RootState } from 'reducers/store'
import { optionsMaker } from 'helpers/fetchOptions'
import { isDev } from 'app/general'
import { User } from 'firebase/auth'

const BASE_DOMAIN = process.env.API

export const updateMyProfile = (profile: Profile, user?: User, passedUid?: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.UPDATE_MY_PROFILE_TRY })

    const uid = getState().userReducer.user?.uid || passedUid

    // const options = {
    //   method: 'Put',
    //   body: JSON.stringify({
    //     profile,
    //   }),
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Put', { profile }, getState, dispatch, user)
    if (!options) {
      dispatch({ type: constants.UPDATE_MY_PROFILE_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(`${BASE_DOMAIN}/user/${uid}/updateProfile`, options)

      const response = await res.json()
      dispatch({
        type: constants.UPDATE_MY_PROFILE_RESPONSE,
        response: response,
      })

      if (response.success) getMyProfile()(dispatch, getState)
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.UPDATE_MY_PROFILE_ERROR, error: error })
    }
  }
}

export const deleteMyAccount = () => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.DELETE_MY_PROFILE_TRY })
    const accessToken = getState().userReducer.token
    const uid = getState().userReducer.user?.uid
    // const options = {
    //   method: 'Delete',
    //   body: JSON.stringify({ uid }),
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Delete', { uid }, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.DELETE_MY_PROFILE_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(`${BASE_DOMAIN}/user/${uid}/`, options)

      const response = await res.json()
      dispatch({
        type: constants.DELETE_MY_PROFILE_RESPONSE,
        response: response,
      })

      if (response.success) {
        dispatch(logout())
      }
    } catch (error) {
      dispatch({ type: constants.DELETE_MY_PROFILE_ERROR, error: error })
    }
  }
}

export const getPublicProfile = (uidToGet: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.GET_PUBLIC_PROFILE_TRY })

    const accessToken = getState().userReducer.token
    const uid = getState().userReducer.user?.uid

    // const options = {
    //   method: 'Get',
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }


    const options = await optionsMaker('Get', null, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.GET_PUBLIC_PROFILE_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(`${BASE_DOMAIN}/user/${uid}/getPublicProfile/${uidToGet}`, options)
      const response = await res.json()
      dispatch({
        type: constants.GET_PUBLIC_PROFILE_RESPONSE,
        uid,
        uidToGet,
        response: response,
      })
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.GET_PUBLIC_PROFILE_ERROR, error: error })
    }
  }
}

export const getPublicProfiles = (uid: string, uids: string[]) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.GET_PUBLIC_PROFILES_TRY })
    const accessToken = getState().userReducer.token

    const params = new URLSearchParams()
    uids.forEach((id) => {
      params.append('uids', id)
    })

    const url = `${BASE_DOMAIN}/user/${uid}/getPublicProfiles?${params}`

    // const options = {
    //   method: 'Get',
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Get', null, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.GET_PUBLIC_PROFILES_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(url, options)
      const response = await res.json()
      dispatch({
        type: constants.GET_PUBLIC_PROFILES_RESPONSE,
        uids,
        response: response,
      })
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.GET_PUBLIC_PROFILES_ERROR, error: error })
    }
  }
}

export const getMyProfile = (passedUser?: User) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({
      type: constants.GET_MY_PROFILE_TRY
    })
    // const accessToken = getState().userReducer.token
    // const uid = getState().userReducer.user?.uid
    // if (!uid) return
    // const options = {
    //   method: 'Get',
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Get', null, getState, dispatch, passedUser)
    if (!options) {
      dispatch({ type: constants.GET_MY_PROFILE_ERROR, error: "no options" })
      return
    }
    const uid = passedUser?.uid ?? getState().userReducer.user?.uid
    if (!uid) {
      dispatch({ type: constants.GET_MY_PROFILE_ERROR, error: "no uid" })
      return
    }
    try {
      const res = await fetch(`${BASE_DOMAIN}/user/${uid}/getProfile/${uid}`, options)
      const response = await res.json()
      dispatch({
        type: constants.GET_MY_PROFILE_RESPONSE,
        response: response,
      })
      if (response.success) {
        return true
      }
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.GET_MY_PROFILE_ERROR, error: error })
    }
  }
}
export const getLatestProfiles = (country?: string, city?: string, quantity: number = 20, isClearOldData?: boolean) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.GET_LATEST_PUBLIC_PROFILES_TRY })
    const accessToken = getState().userReducer.token
    const uid = getState().userReducer.user?.uid
    // const options = {
    //   method: 'Get',
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Get', null, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.GET_LATEST_PUBLIC_PROFILES_ERROR, error: "no options" })
      return
    }
    const params = new URLSearchParams({
      limit: quantity.toString(),
      country: country?.trim() ?? "",
      city: city?.trim() ?? ""
    });

    try {
      const res = await fetch(`${BASE_DOMAIN}/user/${uid}/getLatestProfiles?${params}`, options)
      const response = await res.json()
      if (isClearOldData && response.success && response.profiles.length > 0) {
        await dispatch({
          type: constants.CLEAR_OLD_DATA,
          force: true,
          entryType: EntryType.PROFILE
        })
      }
      dispatch({
        type: constants.GET_LATEST_PUBLIC_PROFILES_RESPONSE,
        response: response,
        uid: uid
      })
    } catch (error) {
      dispatch({ type: constants.GET_LATEST_PUBLIC_PROFILES_ERROR, error: error })
    }
  }
}

export const uploadProfileImage = (imageToUpload: any) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.CHANGE_PROFILE_IMAGE_TRY })
    const uid = getState().userReducer.user?.uid

    const imagePath = 'Profiles/' + uid + '/ProfileImage'

    const ref = storageRef(storage, imagePath);

    // 'file' comes from the Blob or File API
    storageUploadBytes(ref, imageToUpload)
      .then((snapshot) => {
        isDev && console.log('Uploaded a blob or file!');

        storageGetDownloadURL(ref).then(async (downloadURL) => {
          isDev && console.log('File available at', downloadURL);
          await AddImageLinkToProfile(dispatch, getState, imagePath, downloadURL)
        });

      })
      .catch((error) => {
        isDev && console.log(error)
        dispatch({ type: constants.CHANGE_PROFILE_IMAGE_ERROR, error: error })
      });

    // return
    // let imageRef: any
    // try {
    //   imageRef = storageRef(storage, imagePath)
    // } catch (error) {
    //    isDev && console.log(error)
    //   return;
    // }

    // return await storageUploadBytes(imageRef, imageToUpload)
    //   .then(async (snapshot: any) => {
    //     dispatch({
    //       type: constants.CHANGE_PROFILE_IMAGE_RESPONSE,
    //       response: snapshot,
    //       imagePath: imagePath,
    //     })
    //     const imageURL = await getDownloadLink(imagePath, dispatch)
    //     if (!imageURL) {
    //        isDev && console.log("Can't get download link")
    //       return false
    //     }
    //     await AddImageLinkToProfile(dispatch, getState, imagePath, imageURL)
    //   })
    //   .catch((error: any) => {
    //     //  isDev && console.log(error)
    //     dispatch({ type: constants.UPLOAD_IMAGE_EVENT_ERROR, error: error })
    //     return null
    //   })


    // return await storageUploadBytes(imageRef, imageToUpload)
    //   .then(async (snapshot: any) => {
    //     await AddImageLinkToProfile(dispatch, getState, imagePath)
    //     dispatch({
    //       type: constants.CHANGE_PROFILE_IMAGE_RESPONSE,
    //       response: snapshot,
    //       imagePath: imagePath,
    //     })
    //     return true
    //   })
    //   .catch((error: any) => {
    //     //  isDev && console.log(error)
    //     dispatch({ type: constants.CHANGE_PROFILE_IMAGE_ERROR, error: error })
    //     return null
    //   })
  }
}

const AddImageLinkToProfile = async (dispatch: any, getState: any, imagePath: string, imageURL: string) => {
  // const imageURL = await getDownloadLink(imagePath, dispatch)
  // if (!imageURL) {
  //    isDev && console.log("Can't get download link")
  //   return
  // }
  dispatch({
    type: constants.ADD_IMAGE_LINK_TO_PROFILE_TRY,
    image: imageURL,
  })
  const accessToken = getState().userReducer.token
  const uid = getState().userReducer.user?.uid
  // const options = {
  //   method: 'Post',
  //   body: JSON.stringify({
  //     imageUrl: imageURL,
  //     imagePath: imagePath
  //   }),
  //   headers: {
  //     Authorization: 'Bearer ' + accessToken,
  //     'Content-Type': 'application/json',
  //   },
  // }

  const options = await optionsMaker('Post', {
    imageUrl: imageURL,
    imagePath: imagePath
  }, getState, dispatch)
  if (!options) {
    dispatch({ type: constants.ADD_IMAGE_LINK_TO_PROFILE_ERROR, error: "no options" })
    return
  }
  try {
    const res = await fetch(`${BASE_DOMAIN}/user/${uid}/addImage`, options)
    const response = await res.json()
    dispatch({
      type: constants.ADD_IMAGE_LINK_TO_PROFILE_RESPONSE,
      response: response,
      image: imageURL,
    })
  } catch (error) {
    //  isDev && console.log(error)
    dispatch({ type: constants.ADD_IMAGE_LINK_TO_PROFILE_ERROR, error: error })
  }
}

export const updateMyInterests = (interests: string[]) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.UPDATE_MY_INTERESTS_TRY })
    const accessToken = getState().userReducer.token
    const uid = getState().userReducer.user?.uid
    // const options = {
    //   method: 'Post',
    //   body: JSON.stringify({
    //     interests: interests,
    //     uid: uid,
    //   }),
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Post', {
      interests: interests,
      uid: uid,
    }, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.UPDATE_MY_INTERESTS_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(BASE_DOMAIN + '/user/updateMyInterests', options)

      const response = await res.json()
      dispatch({
        type: constants.UPDATE_MY_INTERESTS_RESPONSE,
        response: response,
        interests: interests
      })

      if (response.success) {
        dispatch({ type: constants.GO_TO_PAGE, page: '/' })
      }
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({
        type: constants.UPDATE_MY_INTERESTS_ERROR,
        error: error,
      })
    }
  }
}

export const acceptPrivacyPolicies = () => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.ACCEPT_PRIVACY_POLICIES_TRY })
    const accessToken = getState().userReducer.token
    const uid = getState().userReducer.user?.uid
    // const options = {
    //   method: 'Post',
    //   body: JSON.stringify({
    //     uid: uid,
    //   }),
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Post', {
      uid: uid,
    }, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.ACCEPT_PRIVACY_POLICIES_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(`${BASE_DOMAIN}/user/${uid}/acceptPrivacyPolicies`, options)

      const response = await res.json()
      dispatch({
        type: constants.ACCEPT_PRIVACY_POLICIES_RESPONSE,
        response: response,
      })

      if (response.success) {
        dispatch({ type: constants.GO_TO_PAGE, page: '/' })
      }
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({
        type: constants.ACCEPT_PRIVACY_POLICIES_ERROR,
        error: error,
      })
    }
  }
}
